<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <template v-if="specimenState">
      <specimen-state-form
        :isLoading="isLoading"
        :specimenState="specimenState"
        :onSubmit="onSubmit">
      </specimen-state-form>
    </template>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import SpecimenStateForm from './SpecimenStateForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { specimenStateService } = biobankRegistry;

export default {
  name: 'SpecimenStateUpdate',
  components: {
    SpecimenStateForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Update Preparation',
      enableBackButton: true,
    },
    specimenState: null,
  }),
  async created() {
    const { id } = this.$route.params;
    const specimenState = await specimenStateService.getOne({ id });
    this.specimenState = specimenState;
  },
  methods: {
    async onSubmit(dataChange) {
      const data = Object.assign(this.specimenState || {}, dataChange);
      this.isLoading = true;
      try {
        await specimenStateService.update({ specimenState: data });

        this.$snackbar.showOk({ text: 'Successfully updated specimen state!' });

        this.$router.push({ name: 'specimen-state.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
